import React from 'react'
import { useDispatch } from 'react-redux';
import { termSwitch } from '../../reducers/ToggleAction';
import "./popUp.css"
import { AiOutlineClose } from "react-icons/ai"

const Terms = () => {

  const dispatch = useDispatch();
        
  

  return (
    <div  id='popup'>
      
     <div  id="popup-div">
     <div id='popup-head' >
      <p id='close-div' className='flex justify-end'>
        <span onClick={()=>dispatch(termSwitch())}><AiOutlineClose color='black' /></span>
        </p>
          <h2 className='border-l-0  text-black'>Terms And Conditions</h2>
          <p>Welcome to the Vwrap website. These terms and conditions govern your use of the website, including all pages within the website (collectively referred to below as the “Website”). By accessing the Website, you agree to be bound by these terms and conditions. If you do not agree with any of these terms and conditions, do not use the Website.</p>
     </div>
     <div id='popup-body'>
      <h3>1- <span> USE OF THE WEBSITE</span></h3>
       <p>The content provided on this Website is for informational purposes only. Vwrap makes no representations or warranties, express or implied, regarding the accuracy, completeness, reliability, suitability or availability of the Website or the information, products, services, or related graphics contained on the Website for any purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.</p>
      
      <h3>2- COPYRIGHT</h3>
      <p>All content on the Website, including but not limited to text, graphics, logos, images, and software, is the property of Vwrap or its content suppliers and is protected by copyright law. All rights are reserved. You may not modify, publish, transmit, participate in the transfer or sale of, reproduce, create derivative works based on, distribute, or in any way exploit any of the content, in whole or in part, without the prior written consent of Vwrap.</p>


      <h3>3- TRADEMARKS</h3>
      <p>The Vwrap name and logo, and all related names, logos, product and service names, designs, and slogans are trademarks of Vwrap or its affiliates or licensors. You must not use such marks without the prior written permission of Vwrap.</p>

      <h3>4- LINKS TO THIRD PARTY WEBSITES</h3>
      <p>The Website may contain links to third-party websites that are not owned or controlled by Vwrap. Vwrap has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third-party websites. In addition, Vwrap will not and cannot censor or edit the content of any third-party site. By using the Website, you expressly release Vwrap from any and all liability arising from your use of any third-party website.</p>


      <h3>5- LIMITATION OF LIABILITY</h3>
      <p>In no event shall Vwrap or its officers, directors, employees, or agents be liable for any direct, indirect, incidental, special, consequential, punitive, or exemplary damages arising out of or in connection with your use of the Website, even if Vwrap has been advised of the possibility of such damages. Some jurisdictions do not allow the exclusion or limitation of liability for consequential or incidental damages, so the above limitation may not apply to you.</p>


      <h3>6- INDEMNIFICATION</h3>
      <p>You agree to indemnify and hold harmless Vwrap, its officers, directors, employees, and agents from and against any and all claims, damages, obligations, losses, liabilities, costs, or debt, and expenses (including but not limited to attorney's fees) arising from your use of the Website, your violation of these terms and conditions, or your violation of any third-party rights, including without limitation any copyright, property, or privacy right.</p>


      <h3>7- MODIFICATIONS TO WEBSITE AND TERMS AND CONDITIONS</h3>
      <p>Vwrap reserves the right, at any time and without notice, to modify or discontinue the Website or to modify these terms and conditions. Any modifications will be effective immediately upon posting. Your continued use of the Website following any modifications constitutes your acceptance of the revised terms and conditions.</p>


      <h3>8- GOVERNING LAW AND JURISDICTION</h3>
      <p>These terms and conditions and your use of the Website shall be governed by and construed in accordance with the laws of Pakistan. Any dispute arising out of or in connection with these terms and conditions or your use of the Website shall be resolved by the courts of Pakistan.</p>



     </div>
     </div>
    </div>
  )
}

export default Terms
